<template>
  <div>
    <div
      v-for="item in list"
      :key="item.family_phone_id"
    >
      <div
        :title="
          'id: ' +
            item.family_phone_id +
            '\ncreated: ' +
            item.created_at +
            '\nmodified: ' +
            item.modified_at
        "
      >
        {{ item.number }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'PhoneNumbersList',
    props: ['list']
};
</script>

<style scoped></style>
